import { useEffect, useState } from 'react'
import { BREAKPOINTS, type Breakpoint } from '../tokens/tokens'

/** Subscribes to a media query and re-renders on change. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/**
 * True at or below the named breakpoint, mirroring the SCSS mixins in
 * `tokens/_breakpoints.scss` (all of which are `max-width`).
 *
 *   useBreakpointDown('md')  ⇔  @include md { … }   (<= 991px)
 */
export function useBreakpointDown(name: Breakpoint): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS[name]}px)`)
}

/**
 * The nav moves between the header and the off-canvas sidebar at 992px, i.e. the `md`
 * mixin's 991px ceiling. Its own hook so the magic number lives in exactly one place.
 */
export function useIsMobileNav(): boolean {
  return useBreakpointDown('md')
}
